/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2019 palanik
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.APIFetch = factory());
}(this, function () { 'use strict';

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var express = createCommonjsModule(function (module, exports) {
	/**
	 * toString ref.
	 */
	var toString = {}.toString;


	/**
	 * Normalize the given path string,
	 * returning a regular expression.
	 *
	 * An empty array should be passed,
	 * which will contain the placeholder
	 * key names. For example "/user/:id" will
	 * then contain ["id"].
	 *
	 * @param  {String|RegExp|Array} path
	 * @param  {Array} keys
	 * @param  {Boolean} sensitive
	 * @param  {Boolean} strict
	 * @return {RegExp}
	 * @api private
	 */

	// CREDIT: express - utils.pathRegexp

	exports.parse = function(path, keys, sensitive, strict) {
	  if (toString.call(path) == '[object RegExp]') return path;
	  if (Array.isArray(path)) path = '(' + path.join('|') + ')';
	  path = path
	    .concat(strict ? '' : '/?')
	    .replace(/\/\(/g, '(?:/')
	    .replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?(\*)?/g, function(_, slash, format, key, capture, optional, star){
	      keys.push({ name: key, optional: !! optional });
	      slash = slash || '';
	      return ''
	        + (optional ? '' : slash)
	        + '(?:'
	        + (optional ? slash : '')
	        + (format || '') + (capture || (format && '([^/.]+?)' || '([^/]+?)')) + ')'
	        + (optional || '')
	        + (star ? '(/*)?' : '');
	    })
	    .replace(/([\/.])/g, '\\$1')
	    .replace(/\*/g, '(.*)');
	  return new RegExp('^' + path + '$', sensitive ? '' : 'i');
	};


	/**
	 * Substitute `vars` into the given path
	 * string, returning a string.
	 *
	 * As an optimization, pass keys obtained
	 * from a previous call to parse().
	 *
	 * @param  {String} path
	 * @param  {Object} vars
	 * @param  {Array} keys
	 * @return {String}
	 * @api private
	 */

	exports.transform = function(path, vars, keys) {
	  if (!keys) {
	    keys = [];
	    exports.parse(path, keys);
	  }
	  
	  var out = path;
	  keys.forEach(function(key) {
	    if (!key.optional) {
	      if (!vars[key.name]) { throw new Error('Failed to substitute :' + key.name + ' in pattern ' + path); }
	      out = out.replace(':' + key.name, vars[key.name]);
	    } else {
	      var replacement = vars[key.name] ? '$1' + vars[key.name] : '';
	      out = out.replace(new RegExp('(\\.?\\/?):' + key.name + '\\?'), replacement);
	    }
	  });
	  return out;
	};
	});
	var express_1 = express.parse;
	var express_2 = express.transform;

	var express$1 = express;

	class APIFetchURL {
	  constructor(urlString) {
	    this.url = new URL(urlString); // eslint-disable-line no-undef
	    // Save searchParams & hash as they get overwritten

	    this.searchParams = this.url.searchParams;
	    this.hash = this.url.hash;
	    this.url.search = '';
	    this.url.hash = '';
	  }

	  assignQuery(...qss) {
	    qss.forEach(qs => {
	      Object.keys(qs).forEach(k => {
	        this.searchParams.set(k, qs[k]);
	      });
	    });
	  }

	  joinPath(...paths) {
	    this.url = paths.reduce((acc, pathname) => new URL(pathname, acc), this.url);
	  }
	  /*
	  * Assigns values for express style path parameters in `pathname`
	  *
	  * eg. `pathname` = /a/:param1/b/:param2, `vargs` = 1,2
	  * result = /a/1/b/2
	  */


	  transformPathParams(...vargs) {
	    const placeholders = [];
	    express$1.parse(this.url.pathname, placeholders);
	    const values = {};
	    placeholders.forEach(ph => {
	      values[ph.name] = vargs.shift();
	    });
	    this.url.pathname = express$1.transform(this.url.pathname, values);
	  }

	  toURL() {
	    // rebuild url
	    this.url.search = this.searchParams;
	    this.url.hash = this.hash;
	    return this.url;
	  }

	}

	/*
	 * Adds `pathArray` elements as nested objects to `root`,
	 * finally assigning `val` to leaf key.
	 *
	 * eg. `pathArray` = 'a.b.c' & `value` = 23 results in
	 *   `root.a.b.c = 23`
	 *
	 */

	function nest(root, pathArray, val) {
	  const last = pathArray.pop();
	  const tail = pathArray.reduce((acc, a) => {
	    if (!(a in acc)) {
	      acc[a] = {};
	    }

	    return acc[a];
	  }, root); // This path (or partial) was used earlier?

	  if (typeof tail[last] === 'object') {
	    const descendant = tail[last];
	    tail[last] = val;
	    Object.keys(descendant).forEach(k => {
	      tail[last][k] = descendant[k];
	    });
	    return;
	  }

	  tail[last] = val;
	}
	/*
	 * Cascade through each middleware in the chain.
	 * Each middleware is called with:
	 *  # e - endPoint name (read only)
	 *  # def - endPoint definition (read only)
	 *  # fetchInit - Fetch Init with additional field `url` which is URL object
	 *
	 *  middlewares should return a Promise that resolves to an updated fetchInit
	 *
	 * params:
	 *   fns - array of middleware functions
	 *   e - endpoint name
	 *   endpoint - endpoint definition
	 *   fetchParam - fetchInit
	 */

	function cascade(fns, e, endpoint, fetchParam, ...extra) {
	  return new Promise((resolve, reject) => {
	    function iterate(idx, currVal = fetchParam) {
	      if (idx >= fns.length) {
	        resolve(currVal);
	        return;
	      } // const ret = fns[idx](e, endpoint, currVal);
	      // if (ret.then && ret.catch) { // Is this a Promise object?
	      //   ret
	      //     .then((newVal) => {
	      //       iterate(idx + 1, newVal);
	      //     })
	      //     .catch(reject);
	      // } else { // Not a promise
	      //   iterate((idx + 1), ret);
	      // }


	      try {
	        Promise.resolve(fns[idx](e, endpoint, currVal, ...extra)).then(iterate.bind(this, idx + 1), reject);
	      } catch (err) {
	        reject(err);
	      }
	    }

	    iterate(0, fetchParam);
	  });
	}
	function ensureMiddleware(...fns) {
	  fns.some(f => {
	    if (typeof f !== 'function') {
	      throw TypeError("".concat(f, " is not a middleware function"));
	    }

	    return false;
	  });
	}
	/*
	 * Named middlewares are middleware applicable only to a specific endpoint
	 *
	 * This method will create a global middleware
	 * that checks for the specified name and
	 * calls the actual middleware if the name matches.
	 *
	 * `name` - name of the endpoint
	 * `mw` - list of middlewares
	 */

	function namedMiddleware(name, ...mw) {
	  ensureMiddleware(...mw);
	  return mw.map(m => (epName, definition, fetchInit) => name === epName ? m(epName, definition, fetchInit) : Promise.resolve(fetchInit));
	}
	/*
	 * Merges all inits into one
	 */

	function mergeFetchInit(...inits) {
	  const src = inits.shift();

	  if (inits.length <= 0) {
	    return src;
	  }

	  const first = inits.shift();
	  /* eslint-disable no-undef */

	  if (!(src.headers instanceof Headers)) {
	    src.headers = new Headers(src.headers);
	  }

	  const headers = new Headers(first.headers);
	  /* eslint-enable no-undef */

	  delete first.headers;
	  const next = Object.assign(src, first);
	  first.headers = headers;

	  for (const kv of headers.entries()) {
	    // eslint-disable-line no-restricted-syntax
	    next.headers.set(kv[0], kv[1]);
	  }

	  return mergeFetchInit(next, ...inits);
	}
	/*
	 * Merges all headers into one
	 */

	function mergeHeaders(src, ...headers) {
	  /* eslint-disable no-undef */
	  const first = new Headers(src);
	  /* eslint-enable no-undef */

	  if (headers.length <= 0) {
	    return first;
	  }
	  /* eslint-disable no-undef */


	  const next = new Headers(headers.shift() || {});
	  /* eslint-enable no-undef */

	  for (const kv of next.entries()) {
	    // eslint-disable-line no-restricted-syntax
	    first.set(kv[0], kv[1]);
	  }

	  return mergeHeaders(first, ...headers);
	}
	var utils = {
	  nest,
	  cascade,
	  ensureMiddleware,
	  namedMiddleware,
	  mergeFetchInit,
	  mergeHeaders,
	  APIFetchURL
	};

	const baseURL = Symbol('APIFetch.baseURL');
	const endpoints = Symbol('APIFetch.endpoints');
	const opts = Symbol('APIFetch.opts');
	const optsFetch = Symbol('APIFetch.opts.fetch');
	const middlewares = Symbol('APIFetch.middlewares'); // instance method symbols

	const defineEndpoint = Symbol('APIFetch.defineEndpoint'); // class variable symbols

	const JSEnv = Symbol.for('APIFetch.JS.Environment'); // class method symbols

	const setCustomHeader = Symbol('APIFetch.setCustomHeader');
	/*
	 * Instance methods are API Endpoints
	 *
	 * Reserved methods:
	 *   1. `register` - to register new method
	 *   2. `use` - to add middewares
	 *
	 * All private & static methods are defined/accessed via Symbols
	 *   1. `defineEndpoint` - Defines an endpoint. Called from `register()`
	 *   2. `setCustomHeader` - Middleware as static method to set custom header
	 */

	class APIFetch {
	  /* eslint-disable max-len */

	  /*
	  * baseURL
	  *  - Common, base URL for all API endpoints.
	  *    - Combined with `path` attribute to call API endpoint.
	  *    - Overriden with url attribute of endpoint definition
	  *
	  *  endpoints
	  *  - JSON object that defines each endpoint with `path`, `method` & more.
	  *    - name (key) - function name
	  *    - 'method'  - Any one of the HTTP methods (default: `"GET"`)
	  *    - `path` - route path (relative to baseURL) to API Endpoint. Supports `express` style path parameters
	  *    - `url` - full url to API Endpoint.
	  *    - `headers` (optional) -  an object consists of name-value pairs that make up the request headers for this endpoint.
	  *    - 'query' (optional)  - an object consists of name-value pairs that make up a query string.
	  *    - 'options' (optional)  - options to override or to add specific to the API endpoint.
	  *      - request - 'json' or 'formData'. Body of the request. Default is 'json'.
	  *      - response - 'json', 'text' etc. Default is 'json'. To get raw `Response` object, set this to 'raw'.
	  *      - fetch (object) -  Init options for Fetch call
	  *
	  *  opts (Applicable to all endpoints)
	  *    - request - 'json' | 'formData' | 'text' etc. Default is 'json'.
	  *    - response - 'json' | 'text' | 'blob' | 'arrayBuffer' etc. Default is 'json'. To get raw `Response` object, set this to 'raw'
	  *    - fetch (object) - Init options for Fetch call
	  *    - headers -  an object consists of name-value pairs that make up the request headers to be used on all endpoints.
	  *    - query - an object consists of name-value pairs that make up a query string for all endpoints
	  *    - catchHTTPErrors - Set this option to `true` to treat HTTP status 4xx & 5xx as errors.
	  *    - extraParams - Number of extra parameters passed to middlewares. Use this option to pass parameters to middlewares.
	  */

	  /* eslint-enable max-len */
	  constructor(baseURL_, endpoints_ = {}, opts_ = {}) {
	    this[baseURL] = baseURL_; // baseURL for all API endpoints

	    this[endpoints] = {}; // key-value - function_name: endpoint_definition

	    this[opts] = opts_; // options for all API endpoints

	    this[middlewares] = []; // List of middleware added via `this.use()`
	    // By default, expect json in request body

	    this[opts].request = this[opts].request || 'json'; // request body
	    // By default, expect json response

	    this[opts].response = this[opts].response || 'json'; // response body
	    // Extract fetch options from global opts

	    this[optsFetch] = this[opts] && this[opts].fetch ? this[opts].fetch : {};
	    delete this[opts].fetch; // No changes allowed to opts

	    Object.freeze(this[opts]); // Define all endpoints

	    Object.entries(endpoints_ || {}).forEach(e => this.register(...e)); // (name, def)
	    // Set custom userAgent for node apps

	    if (APIFetch[JSEnv] && APIFetch[JSEnv].isNode) {
	      this.use(APIFetch[setCustomHeader]);
	    }
	  } // Function to manually add endpoints


	  register(e, endPoint) {
	    this[endpoints][e] = endPoint;
	    return this[defineEndpoint](e, endPoint); // eslint-disable-line no-use-before-define
	  } // Function to Register middlewares


	  use(...mw) {
	    // Is named middleware?
	    if (mw.length > 1 && typeof mw[0] === 'string') {
	      this[middlewares].push(...utils.namedMiddleware(...mw));
	    } else {
	      utils.ensureMiddleware(...mw);
	      this[middlewares].push(...mw);
	    }

	    return this;
	  }

	  toString() {
	    return JSON.stringify({
	      baseURL: this[baseURL],
	      endpoints: this[endpoints],
	      options: this[opts]
	    });
	  }

	  [Symbol.iterator]() {
	    let i = 0;
	    const keys = Object.keys(this[endpoints]);
	    const self = this;
	    return {
	      next() {
	        if (i < keys.length) {
	          const k = keys[i];
	          const f = k.split('.').reduce((acc, p) => acc[p], self);
	          i += 1;
	          return {
	            done: false,
	            value: [k, f]
	          };
	        }

	        return {
	          done: true
	        };
	      }

	    };
	  } // * [Symbol.iterator]() {
	  //   const self = this;
	  //   for (const k of Object.keys(this[endpoints])) {
	  //     yield [k, k.split('.').reduce((acc, p) => acc[p], self)];
	  //   }
	  // }

	  /*
	   *  options
	   *    - opts - global
	   *    - epOptions - opts + endPoint.options
	   *
	   *  query string
	   *    - opts.query  - global
	   *    - endPoint.querystring  - from endPoint definition
	   *    - epQuery - opts.query + endPoint.querystring
	   *    - qs - query string argument in the endpoint function
	   *
	   *  fetch init
	   *    - optsFetch - global. Extracted from opts.fetch
	   *    - epOptions.fetch - from endPoint definition
	   *    - epInit - optsFetch + epOptions.fetch
	   */


	  [defineEndpoint](e, endPoint) {
	    const ef = e.split('.');

	    if (ef[0] === 'register' || ef[0] === 'use') {
	      throw new RangeError("\"".concat(ef[0], "\" is a reserved function name. Consider using an alias (eg. \"_").concat(ef[0], "\")."));
	    } // Init - from constructor (optsFetch) & definition(endPoint.options.fetch)


	    const epInit = utils.mergeFetchInit({}, this[optsFetch], endPoint.options && endPoint.options.fetch || {});
	    epInit.headers = utils.mergeHeaders(epInit.headers, this[opts].headers, endPoint.headers); // `GET` is the default HTTP_METHOD

	    if (!epInit.method) {
	      epInit.method = endPoint.method || 'GET';
	    } // options for this endpoint


	    const epOptions = Object.assign({}, this[opts], endPoint.options); // QueryString defined in endpoint definition

	    const epQuery = Object.assign({}, epOptions.query, endPoint.query);
	    const self = this; // arguments order - param1, param2, ..., querystring?, body?

	    function apiEndpoint(...vargs) {
	      const afUrl = new utils.APIFetchURL(endPoint.url || self[baseURL]);

	      if (!endPoint.url) {
	        afUrl.joinPath(endPoint.path);
	      }

	      afUrl.assignQuery(epQuery);
	      const callInit = utils.mergeFetchInit({}, epInit); // Save extraParams

	      let mwParams = [];

	      if (epOptions.extraParams) {
	        const extraParams = parseInt(epOptions.extraParams, 10) || 0;
	        mwParams = extraParams > 0 ? vargs.splice(-extraParams) : [];
	      } // Start from last argument. body for 'PATCH', 'POST' & 'PUT'


	      if (['PATCH', 'POST', 'PUT'].indexOf(callInit.method) >= 0) {
	        let body = vargs.pop(); // Only handle json request body. Fetch will take care of the rest

	        if (epOptions.request === 'json') {
	          if (typeof body !== 'string') {
	            body = JSON.stringify(body);
	          }

	          if (!callInit.headers.get('Content-Type')) {
	            callInit.headers.set('Content-Type', 'application/json');
	          }
	        }

	        callInit.body = body;
	      } // Next comes query string


	      if (vargs.length > 0 && !Array.isArray(vargs[vargs.length - 1]) // only if plain object
	      && typeof vargs[vargs.length - 1] === 'object') {
	        const qs = vargs.pop(); // 'call query strings' override 'definition query strings'

	        afUrl.assignQuery(qs);
	      } // finally, path params


	      try {
	        // If path had place holders, arguments contain values
	        afUrl.transformPathParams(...vargs);
	      } catch (transformError) {
	        return Promise.reject(transformError);
	      } // Add url object to Init for middlewares


	      callInit.url = afUrl.toURL(); // Call middlewares

	      return utils.cascade(self[middlewares], e, Object.freeze(endPoint), callInit, ...mwParams) // Ready to call fetch?
	      .then(fetchInit => {
	        const {
	          url
	        } = fetchInit;
	        delete fetchInit.url; // eslint-disable-line no-param-reassign

	        return fetch(url.toString(), fetchInit) // eslint-disable-line no-undef
	        // post process
	        .then(res => {
	          if (epOptions.catchHTTPErrors && !res.ok) {
	            throw res;
	          }

	          if (typeof epOptions.response === 'function') {
	            return epOptions.response(res);
	          }

	          if (typeof res[epOptions.response] === 'function') {
	            // call response.json(), response.text() ...
	            return res[epOptions.response]();
	          }

	          return res;
	        });
	      });
	    }

	    utils.nest(this, ef, apiEndpoint);
	    return this;
	  } // Middleware to set custom User-Agent


	  static [setCustomHeader](e, endpoint, fetchInit) {
	    if (!fetchInit.headers.has('User-Agent') && APIFetch[JSEnv].userAgent) {
	      fetchInit.headers.set('User-Agent', "".concat(APIFetch[JSEnv].userAgent, " (").concat(e, ")"));
	    }

	    return Promise.resolve(fetchInit);
	  }

	}

	APIFetch[JSEnv] = undefined;
	var APIFetch_1 = APIFetch;

	return APIFetch_1;

}));
